import React from 'react';
import { ResetPasswordModal } from '~/legacy/components/modals';
import SetPassword from './SetPassword';

const ResetPassword = () => {
  return <SetPassword SetPasswordModalClass={ResetPasswordModal} />;
};

export default ResetPassword;
